import api from '@functions/api'

import type { UserModel } from '@models/user'
import type { AppDispatch } from '@redux/store'
import type {
  Action, ActionResult, EntityOptions, Errors, FetchRequestPayload,
} from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/currentUser/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/currentUser/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/currentUser/FETCH_FAILURE'

export type CurrentUserModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
  result: object,
}

// Initial State
const initialState: CurrentUserModuleState = {
  errors: [],
  loaded: false,
  loading: false,
  result: {},
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload: FetchRequestPayload = {}) {
  return {
    type: FETCH_SUCCESS,
    // @ts-expect-error TS2339
    result: payload.data,
  }
}

export function fetchFailure(errors: Errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadCurrentUser(options: EntityOptions = {}) {
  return (dispatch: AppDispatch): Promise<ActionResult<UserModel>> => {
    dispatch(fetchRequest())

    const promise = api('/users/me.json', options)
      .then(({ data }): { success: true, data: UserModel } => {
        // @ts-expect-error TS2353
        dispatch(fetchSuccess({ data }))

        return { success: true, data }
      })
      .catch((data): { success: false, errors: string[] } => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: CurrentUserModuleState = initialState,
  action: Action = { type: '' },
) {
  switch (action.type){
    case FETCH_REQUEST:
      return { ...state, loading: true }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: true,
        loading: false,
        result: action.result,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors: action.errors,
        loaded: false,
        loading: false,
      }
    default:
      return state
  }
}
